export default "__VITE_ASSET__v6s4omCB__"